import { clearCachedByPrefix, deleteCached } from './cacheFetch.js';
import appQueryClient from '../queries/queryClient';

export const invalidateHomeSummaryCaches = ({ communityId } = {}) => {
  if (communityId) {
    deleteCached(`home-summary:${communityId}`, { storageKey: `home-summary:${communityId}` });
    clearCachedByPrefix(`home-summary:${communityId}:`);
    return;
  }
  clearCachedByPrefix('home-summary:');
};

export const invalidateActivityCaches = ({ activityId } = {}) => {
  deleteCached('activities:list', { storageKey: 'activitiesCache' });
  clearCachedByPrefix('activities:');
  invalidateHomeSummaryCaches();
  if (activityId) {
    deleteCached(`activities:${activityId}`);
  }
};

export const invalidateEventCaches = ({ eventId } = {}) => {
  deleteCached('events:list', { storageKey: 'events' });
  clearCachedByPrefix('events:item:');
  appQueryClient.invalidateQueries({ queryKey: ['events', 'list'] });
  appQueryClient.invalidateQueries({ queryKey: ['discover', 'events'] });
  invalidateHomeSummaryCaches();
  if (eventId) {
    deleteCached(`events:item:${eventId}`);
  }
};

export const invalidatePostCaches = ({ communityId, postId } = {}) => {
  if (communityId) {
    deleteCached(`news:feed:${communityId}`);
    invalidateHomeSummaryCaches({ communityId });
  } else {
    clearCachedByPrefix('home-summary:');
  }
  if (postId) {
    deleteCached(`posts:item:${postId}`);
  }
};

export const invalidateMemberCaches = ({ communityId, userId } = {}) => {
  clearCachedByPrefix('members:');
  clearCachedByPrefix('community:members:');
  if (communityId) {
    deleteCached(`members:community:${communityId}`);
    deleteCached(`community:members:${communityId}`);
    invalidateHomeSummaryCaches({ communityId });
  } else {
    invalidateHomeSummaryCaches();
  }
  if (userId) {
    deleteCached(`users:item:${userId}`);
    deleteCached(`households:by-member:${userId}`);
  }
};

export const invalidateHouseholdCaches = ({ householdId, communityId, memberId } = {}) => {
  clearCachedByPrefix('households:list:');
  if (communityId) {
    deleteCached(`households:list:${communityId}`);
    invalidateHomeSummaryCaches({ communityId });
  }
  if (householdId) {
    deleteCached(`households:item:${householdId}`);
  }
  if (memberId) {
    deleteCached(`households:by-member:${memberId}`);
  }
  invalidateMemberCaches({ communityId, userId: memberId });
};

export const invalidateVenueCaches = ({ communityId, venueId } = {}) => {
  clearCachedByPrefix('venues:list:');
  clearCachedByPrefix('venues:eligible:');
  if (communityId) {
    deleteCached(`venues:list:${communityId}`);
    invalidateHomeSummaryCaches({ communityId });
  }
  if (venueId) {
    deleteCached(`venues:item:${venueId}`);
  }
};

export default {
  invalidateHomeSummaryCaches,
  invalidateActivityCaches,
  invalidateEventCaches,
  invalidatePostCaches,
  invalidateMemberCaches,
  invalidateHouseholdCaches,
  invalidateVenueCaches,
};
